import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCES,
  GET_MENUS_SUCCESS,
  LOGIN_SUCCESS_AD,
  CHANGE_USERSCHOOL,
  SHOW_VERITY
}
  from './mutation-type'

const mutations = {
  [LOGIN_SUCCESS] (state, data) {
    state.userInfo = data;
    state.showVerity = false
    if (window.xkwTracker) {
      window.xkwTracker.$user_id = data.xkwUserId
      window.xkwTracker.$school_id = data.xkwSchoolId
    }
    delete data.perms
    YJ_SCHOOL_STORAGE.setItem('userInfo', JSON.stringify(data));
  },
  [LOGOUT_SUCCES] (state, data) {
    state.userInfo = '';
    if (window.xkwTracker) {
      window.xkwTracker.$user_id = ''
      window.xkwTracker.$school_id = ''
    }
  },
  [GET_MENUS_SUCCESS] (state, data) {
    state.menus = data
  },
  [LOGIN_SUCCESS_AD] (state, data) {
    state.isAdmin = data
  },
  [SHOW_VERITY] (state, data) {
    state.showVerity = data
  },
  [CHANGE_USERSCHOOL] (state, _userInfo) {
    state.userInfo.schoolId = _userInfo.id;
    state.userInfo.schoolName = _userInfo.schoolName;
    YJ_SCHOOL_STORAGE.setItem('userInfo', JSON.stringify(state.userInfo));
  },
}

export default mutations
